<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <div class="robotMovementScreen" *ngIf="showRobotMovementScreen === true">
    <p>{{ 'app.robot_walking_1' | translate }}</p>
    <img src="assets/img/robot_walking.svg" />
    <p>{{ 'app.robot_walking_2' | translate }}</p>
  </div>
</ion-app>
